import React, { createContext, useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
// import { firebaseConfig as firebase } from "../firebase";
import firebase from 'firebase/app'
import "firebase/auth"
export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [currentUser, setUser] = useState({});
  let history = useHistory();

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
      if (user) {
        history.push("/h");
      } else {
        history.push("/");
      }
    });
  }, [currentUser, history]);

  const value = { currentUser };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
